import React from "react";
import Typography from "@material-ui/core/Typography";
import { useHistory } from "react-router-dom";

var dayjs = require("dayjs");
var relativeTime = require("dayjs/plugin/relativeTime");
var localizedFormat = require("dayjs/plugin/localizedFormat");
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

export default function GetNews(props) {
  const history = useHistory();
  const item = props.data ? props.data[1] : null;

  if (!item) return null;

  let imageSrc = "https://res.cloudinary.com/urhub/image/upload/v1791947918/promo.webp";
  try {
    const parsed = typeof item.image === "string" ? JSON.parse(item.image) : item.image;
    if (parsed && parsed.img1) {
      imageSrc = parsed.img1;
    }
  } catch (e) {
    if (typeof item.image === "string" && item.image.startsWith("http")) {
      imageSrc = item.image;
    }
  }

  const handleNavigate = () => {
    if (item.slug && item.slug.includes("https://")) {
      window.location.replace(item.slug);
    } else if (item.slug) {
      history.push("/blog/" + item.slug);
    }
  };

  return (
    <div
      style={{
        width: "340px",
        marginRight: "20px",
        marginTop: "12px",
        marginBottom: "20px",
        flexShrink: 0,
      }}
    >
      <div
        onClick={handleNavigate}
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "14px",
          overflow: "hidden",
          border: "1px solid #e2e8f0",
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          height: "360px",
          transition: "all 0.2s ease",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.borderColor = "#cbd5e1";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.05)";
          e.currentTarget.style.transform = "translateY(-2px)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.borderColor = "#e2e8f0";
          e.currentTarget.style.boxShadow = "none";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        {/* Image Container */}
        <div
          style={{
            height: "180px",
            width: "100%",
            overflow: "hidden",
            backgroundColor: "#0f172a",
          }}
        >
          <img
            src={imageSrc}
            alt={item.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        {/* Content */}
        <div
          style={{
            padding: "18px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            flexGrow: 1,
          }}
        >
          <div>
            {item.jam && (
              <span
                style={{
                  fontSize: "12px",
                  color: "#94a3b8",
                  fontWeight: 500,
                  display: "block",
                  marginBottom: "6px",
                }}
              >
                {dayjs(item.jam).fromNow()}
              </span>
            )}
            <Typography
              variant="h6"
              style={{
                fontWeight: 700,
                color: "#0f172a",
                fontSize: "15px",
                lineHeight: 1.4,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {item.title || "Loading..."}
            </Typography>
          </div>

          <div
            style={{
              paddingTop: "10px",
              borderTop: "1px solid #f1f5f9",
            }}
          >
            <span
              style={{
                color: "#DE148C",
                fontWeight: 600,
                fontSize: "13px",
              }}
            >
              Baca Selengkapnya →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
